import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';

const useDebouncedValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const debouncedSetValue = useMemo(
    () => debounce((nextValue: T) => setDebouncedValue(nextValue), delay),
    [delay]
  );

  useEffect(() => {
    debouncedSetValue(value);

    return () => {
      debouncedSetValue.cancel();
    };
  }, [debouncedSetValue, value]);

  return debouncedValue;
};

export default useDebouncedValue;
